/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseGetControlQueryResultValidationResult } from './CaseGetControlQueryResultValidationResult';
import {
	CaseGetControlQueryResultValidationResultFromJSON,
	CaseGetControlQueryResultValidationResultFromJSONTyped,
	CaseGetControlQueryResultValidationResultToJSON,
	CaseGetControlQueryResultValidationResultToJSONTyped,
} from './CaseGetControlQueryResultValidationResult';
import type { EasyClaimDocumentType } from './EasyClaimDocumentType';
import {
	EasyClaimDocumentTypeFromJSON,
	EasyClaimDocumentTypeFromJSONTyped,
	EasyClaimDocumentTypeToJSON,
	EasyClaimDocumentTypeToJSONTyped,
} from './EasyClaimDocumentType';

/**
 *
 * @export
 * @interface CaseGetControlCommandResult
 */
export interface CaseGetControlCommandResult {
	/**
	 *
	 * @type {string}
	 * @memberof CaseGetControlCommandResult
	 */
	id?: string | null;
	/**
	 *
	 * @type {Array<CaseGetControlQueryResultValidationResult>}
	 * @memberof CaseGetControlCommandResult
	 */
	validationResults?: Array<CaseGetControlQueryResultValidationResult> | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof CaseGetControlCommandResult
	 */
	isRequired?: boolean;
	/**
	 *
	 * @type {string}
	 * @memberof CaseGetControlCommandResult
	 */
	value?: string | null;
	/**
	 *
	 * @type {EasyClaimDocumentType}
	 * @memberof CaseGetControlCommandResult
	 */
	documentType?: EasyClaimDocumentType;
}

/**
 * Check if a given object implements the CaseGetControlCommandResult interface.
 */
export function instanceOfCaseGetControlCommandResult(
	value: object
): value is CaseGetControlCommandResult {
	return true;
}

export function CaseGetControlCommandResultFromJSON(json: any): CaseGetControlCommandResult {
	return CaseGetControlCommandResultFromJSONTyped(json, false);
}

export function CaseGetControlCommandResultFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CaseGetControlCommandResult {
	if (json == null) {
		return json;
	}
	return {
		id: json['id'] == null ? undefined : json['id'],
		validationResults:
			json['validationResults'] == null
				? undefined
				: (json['validationResults'] as Array<any>).map(
						CaseGetControlQueryResultValidationResultFromJSON
					),
		isRequired: json['isRequired'] == null ? undefined : json['isRequired'],
		value: json['value'] == null ? undefined : json['value'],
		documentType:
			json['documentType'] == null
				? undefined
				: EasyClaimDocumentTypeFromJSON(json['documentType']),
	};
}

export function CaseGetControlCommandResultToJSON(json: any): CaseGetControlCommandResult {
	return CaseGetControlCommandResultToJSONTyped(json, false);
}

export function CaseGetControlCommandResultToJSONTyped(
	value?: CaseGetControlCommandResult | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		id: value['id'],
		validationResults:
			value['validationResults'] == null
				? undefined
				: (value['validationResults'] as Array<any>).map(
						CaseGetControlQueryResultValidationResultToJSON
					),
		isRequired: value['isRequired'],
		value: value['value'],
		documentType: EasyClaimDocumentTypeToJSON(value['documentType']),
	};
}
